import styled from 'styled-components';

const TextoContainer =  styled.p`
    color: ${props => props?.cor ? props.cor : '#333'};
	font-size: ${props => props?.tamanho ? props.tamanho : '14px'};
	${props => props?.weight && 'font-weight:'+props.weight+ ';'};
`;

export const  SistemaContainer =  styled.div`
	padding-left: 50px;
`;


export const Texto = ({children, cor, tamanho,className, weight }) => {
	return(
		<TextoContainer className={className} cor={cor} tamanho={tamanho} weight={weight}>{children}</TextoContainer>
	)
}
